<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div class="fill-height">
        <md-table v-model="series" md-sort="title" md-sort-order="asc" @md-selected="view" md-card md-fixed-header>
          <md-table-toolbar>
            <div class="md-toolbar-section-start">
              <h1 class="md-title">Series</h1>
            </div>

            <div class="md-toolbar-section-end">
              <div class="md-layout">
                <div class="md-layout-item">
            <md-field md-clearable>
              <md-input placeholder="Search by name..." v-model="search" @input="doFilter" />
            </md-field>
                </div>
                <div class="md-layout-item md-size-15" style="text-align: right">
              <md-button @click="addSeries" class="md-raised md-primary">Add</md-button>
                </div>
              </div>
            </div>
          </md-table-toolbar>

          <md-table-empty-state
            md-label="No Series found"
            :md-description="`No series found for this '${search}' query. Try a different search term or create a new series.`">
            <md-button class="md-primary md-raised" @click="addSeries">Create New Series</md-button>
          </md-table-empty-state>

          <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
            <md-table-cell md-label="Title" md-sort-by="title">{{ item.title }}</md-table-cell>
            <md-table-cell md-label="# of Messages" md-numeric>{{ item.messages_count}}</md-table-cell>
            <md-table-cell md-label="# of Members" md-numeric>{{ item.assignments_count }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SeriesList",
  props: {
    series: Array,
    detailLink: String
  },
  methods: {
    addSeries: function() {
      this.$emit('add')
    },
    doFilter: function() {
      this.$emit('filter', this.search)
    },
    view: function(serie) {
      this.$router.push(`${this.detailLink}/${serie.series_id}`)
    },
  },
  data: function() {
    return {
      search: null
    }
  },
  filters: {
    count: function (value) {
      if(value) return value.length
      else return 0
    }
  }
}
</script>
<style lang="scss" scoped>
.fill-height {
}
</style>
